import React from 'react';

const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_accessibility-2030/artifacts/nw15sq62_500b886b-8db8-4b51-889b-2271da73225e.jpeg";

export const TravelAbilityLogo = ({ size = 'md' }) => {
  const sizes = {
    sm: 'h-10',
    md: 'h-14',
    lg: 'h-20',
    xl: 'h-28'
  };

  return (
    <img 
      src={LOGO_URL}
      alt="TravelAbility - Your Accessibility Partner"
      className={`${sizes[size] || sizes.md} w-auto rounded-lg bg-white p-1`}
      data-testid="travelability-logo"
    />
  );
};

export const TravelAbilityWordmark = ({ showTagline = true }) => {
  return (
    <div className="flex justify-center" data-testid="travelability-wordmark">
      <img 
        src={LOGO_URL}
        alt="TravelAbility - Your Accessibility Partner"
        className="h-16 sm:h-20 w-auto rounded-lg bg-white p-2"
      />
    </div>
  );
};

export default TravelAbilityLogo;
